import { get, isEmpty } from "lodash";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { KEYS, RELATIONSHIP } from "utils/constants";
import Template from "../Template";
import View from "./View";

const SocialSecurityNumber = ({
  tracer,
  project,
  onNext,
  currentStatus,
  onBack,
  updateUrl,
}) => {
  const subscriptionId =
    get(project, "fields.currentSubscription") ||
    localStorage.getItem(KEYS.SUBSCRIPTION_ID);

  const { data, loading } = useQuery(graphql.queries.SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });

  const onSubmit = (data) => {
    const source = localStorage.getItem(KEYS.SOURCE);
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    const relatedPersons = get(project, "contact.relatedPersons", []).filter(
      (_) => _,
    );
    const hasChildren = !!relatedPersons.filter(
      ({ relationship }) => relationship === RELATIONSHIP.CHILD,
    ).length;
    const hasSpouse = !isEmpty(
      relatedPersons.find(
        ({ relationship }) => relationship === RELATIONSHIP.SPOUSE,
      ),
    );

    onNext({
      payload: {
        ...data,
        fields: {
          ...get(data, "fields"),
          hasRelatedPersons: {
            hasChildren,
            hasSpouse,
          },
        },
      },
    });
  };

  return (
    <Template
      progress={currentStatus.progress}
      onBack={onBack}
      loading={loading}
      project={project}
      HeaderComponent={{
        subscription: get(data, "subscription"),
        tracer,
        project,
        contact: get(project, "contact"),
      }}
      View={
        <View
          project={project}
          locked={get(data, "subscription.locked", false)}
          onNext={onSubmit}
          onBack={onBack}
        />
      }
      contact={get(project, "contact")}
    />
  );
};
export default SocialSecurityNumber;
